import React, { useCallback, useState, useRef, useMemo, useEffect } from 'react';
import { Grid, Button, Row, Col } from 'antd';
import { useSelector } from 'react-redux';
import indexStyles from '../index.less';
import { localeSelector } from 'src/selector/app';
import { JoinClassName } from 'src/utils/utils';
import Image from 'next/image';
import CommonGetDemoTopSection, { CommonGetDemoTopSectionOnLeft } from '../CommonGetDemoTopSection';
import AutoPlayer from 'src/components/AutoPlayer';
import { FormattedMessage } from 'react-intl';
import Link from 'next/link';

const { useBreakpoint } = Grid;

const ProductTopIntroduction = ({ title, description, descriptionHtml, poster, videoId, topLink }) => {
  return (
    <React.Fragment>
      <CommonGetDemoTopSection
        title={title}
        desc={description}
        descHtml={descriptionHtml}
        topLink={topLink}
        className={JoinClassName(indexStyles.max1440WidthFull, indexStyles.productTopIntroduction)}
        outerClassName={JoinClassName(indexStyles.whiteBackgroundcolor)}
      >
        <div style={{ textAlign: 'center' }}>
          {topLink ? (
            <Button shape="round" type="primary" href={topLink.href} size="large" onClick={() => {}}>
              {topLink.text}
            </Button>
          ) : (
            <Link href="/get-a-demo">
              <a>
                <Button shape="round" type="primary" size="large" style={{ paddingTop: 0, paddingBottom: 0 }}>
                  <FormattedMessage id="home.get-demo.bitton" />
                </Button>
              </a>
            </Link>
          )}
        </div>
      </CommonGetDemoTopSection>

      {poster && (
        <div className={JoinClassName(indexStyles.productVideoContainerWrapper)}>
          <Row align={'middle'} justify={'center'} wrap={false}>
            <Col xs={23} md={22} lg={18}>
              <div className={JoinClassName(indexStyles.productVideoContainer)}>
                <AutoPlayer
                  poster={`${poster}`}
                  posterAlt={title}
                  posterRatio={videoId ? 428 / 641 : 9 / 16}
                  youtubeVideoId={videoId}
                  autoPlayOnCover={true}
                  centerButtonType={'pureButton'}
                  canPause={true}
                />
              </div>
            </Col>
          </Row>
        </div>
      )}
    </React.Fragment>
  );
};

export const ProductTopIntroductionForLoyaltyMode = ({ title, description, poster, videoId, topLink }) => {
  const screens = useBreakpoint();
  return (
    <Row align={'middle'} justify={'center'} wrap={false}>
      <Col xs={24}>
        <div
          className={JoinClassName(
            indexStyles.productTopIntroductionForLoyaltyModeWrapper,
            screens.md ? indexStyles.forMDDevice : ''
          )}
        >
          <CommonGetDemoTopSectionOnLeft
            title={title}
            desc={description}
            topLink={topLink}
            className={JoinClassName(indexStyles.max1440WidthFull, indexStyles.productTopIntroduction)}
            // outerClassName={JoinClassName(indexStyles.whiteBackgroundcolor)}
          >
            <div style={{ textAlign: 'left' }}>
              {topLink ? (
                <Button
                  shape="round"
                  href={topLink.href}
                  size="large"
                  onClick={() => {}}
                  style={{ color: '#E00051', borderColor: '#E00051' }}
                >
                  {topLink.text}
                </Button>
              ) : (
                <Link href="/get-a-demo">
                  <a>
                    <Button
                      shape="round"
                      size="large"
                      style={{ color: '#E00051', borderColor: '#E00051', paddingTop: 0, paddingBottom: 0 }}
                    >
                      <FormattedMessage id="home.get-demo.bitton" />
                    </Button>
                  </a>
                </Link>
              )}
            </div>
          </CommonGetDemoTopSectionOnLeft>
          <div className={JoinClassName(indexStyles.productLoyaltyVideoContainerWrapper)}>
            <Row align={'middle'} justify={'center'} wrap={false}>
              <Col xs={23}>
                <div className={JoinClassName(indexStyles.productVideoContainer)}>
                  <AutoPlayer
                    poster={`${poster}`}
                    posterAlt={title}
                    posterRatio={videoId ? 428 / 641 : 9 / 16}
                    youtubeVideoId={videoId}
                    autoPlayOnCover={true}
                    centerButtonType={'pureButton'}
                    canPause={true}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Col>
    </Row>
  );
};
export default ProductTopIntroduction;
